export default __webpack_public_path__ + "static/media/download-pdf.846bf544.svg";